<script setup lang="ts"></script>

<template>
  <div class="slider-container">
    <slot />
  </div>
</template>

<style scoped lang="postcss">
.slider-container {
  @apply relative h-full w-full overflow-hidden rounded-xl bg-gray-100;
  min-height: 350px;
  @media screen(max-lg) {
    min-height: 375px;
  }
  @media screen(max-md) {
    min-height: 450px;
  }
}
</style>
